import axios from "axios";
const instance = axios.create({
  ///baseURL: "http://localhost:2002/",
  baseURL: "https://api.divinebricks.com/",
});
export default instance;
